import React, { useState } from 'react';
import { Tag, TruncateButton } from '../../styledComponents';
import { Add as AddIcon, Remove as RemoveIcon } from '@material-ui/icons';
import { SubHeader, TagDisplay } from '../styles';
import styled from 'styled-components';
import { DEFAULT_MAX_CATEGORIES_DISPLAY } from '../../constants';
import { Body12 } from '../../../common/Typography';

const ProfileLabel = styled(SubHeader)`
  margin-bottom: 0.6rem !important;
  font-weight: 800 !important;
`;

const ProfileDescription = styled(Body12)`
  margin-bottom: 0.8rem !important;
`;

export function TopCategories({ user, userLookingForList, color, viewType }) {
  const [showAllCategories, setShowAllCategories] = useState(false);
  const userLookingForListDisplay = showAllCategories
    ? userLookingForList
    : userLookingForList.slice(0, DEFAULT_MAX_CATEGORIES_DISPLAY);

  return (
    <TagDisplay>
      <ProfileLabel>My goals</ProfileLabel>
      {viewType === 'view' && (
        <ProfileDescription>
          We use your goals to match you with people who can help. Update
          anytime to refine your matches.
        </ProfileDescription>
      )}
      <div>
        <div>
          {user.topcategories.length > 0
            ? (userLookingForListDisplay ?? []).map(value => {
                return (
                  <Tag key={`${value}-tag`} color={color}>
                    {value}
                  </Tag>
                );
              })
            : 'No top categories yet.'}
        </div>
        {userLookingForList.length > DEFAULT_MAX_CATEGORIES_DISPLAY && (
          <TruncateButton
            size="small"
            onClick={() => setShowAllCategories(!showAllCategories)}
            startIcon={showAllCategories ? <RemoveIcon /> : <AddIcon />}
          >
            {showAllCategories ? 'Less' : 'More'}
          </TruncateButton>
        )}
      </div>
    </TagDisplay>
  );
}
